export const engagementContentBlockLocales = "/engagement/content_block_locales";
